import { render, staticRenderFns } from "./AddAffiliation.vue?vue&type=template&id=5a04b82e&scoped=true"
import script from "./AddAffiliation.vue?vue&type=script&lang=js"
export * from "./AddAffiliation.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a04b82e",
  null
  
)

export default component.exports